// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22rIp","colMin":"styles_colMin__1QL0B"};